import React from 'react';
import brandData from '../data/brandData.json';
import logo from '../assets/logo.jpg';  // Import the logo image
import '../styles/navbarBrand.css';

const NavbarBrand = () => {
  return (
    <div className="logo">
      <a href={brandData.link}>
        <img src={logo} alt={brandData.alt} className="logo-image" />
        <span className="logo-text">{brandData.logoText}</span>
      </a>
    </div>
  );
};

export default NavbarBrand; 